module.exports = __webpack_public_path__ + "img/214.a1bbe9bc.png";